import { TableItemsV2 } from "@/apis/preview/v2/types";
import { TableWithCopy } from "@/components/table-preview/table/render-table";
import { cn } from "@/lib/utils";

export const XBRLPreview = ({
  isError,
  tablePreview,
  period,
  density = "default",
}: {
  isError: boolean;
  tablePreview: TableItemsV2;
  period: "CURRENT" | "PRIOR";
  density?: "default" | "compact";
}) => {
  if (isError) {
    return (
      <div className="flex flex-col p-[16px] items-center justify-center gap-[16px] min-h-[400px] bg-white rounded-2xl">
        <span className="label-1-normal-medium text-red-500">
          데이터를 불러오는 중 오류가 발생했습니다.
        </span>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6 w-full max-w-full">
      <div
        className={cn(
          "flex flex-col items-start gap-2.5 min-w-0 bg-white rounded-2xl",
          density === "compact" ? "p-0" : "p-4",
        )}
      >
        <div className="flex flex-col w-full gap-[12px]">
          <div
            data-final-period-label
            className="flex flex-col items-start gap-1"
          >
            <span className="label-1-normal-medium">
              {period === "CURRENT" ? "당기" : "전기"}
            </span>
          </div>
          <div className="w-full max-w-full relative group min-w-0">
            <TableWithCopy
              table={tablePreview}
              tableIndex={0}
              period={period}
              density={density}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
